/* ==========================================================================

Renders:
This file handles logic that renders on the product-template.liquid.

Purpose: 
This file handles the logic of: 
    - product-tool-features.liquid

Helpers created:
    - changeVisibility() → hides/shows elements (quantity button & label, length button & label)
    - checkCounter() → increments value. Doesn't let it go below 1.
    - setUpButtons() →
    - setUpQtyButtons() →
    - checkInput()
    - editLengthInput()
    - editQtyInput()

Main functions:
    - updatePage()

Note:
*Assumes user is not logged in.
- Renders at theme.css.liquid, Line 427

========================================================================== 

*/


// Retrieves and stores elements from project-tool-features.liquid
const mainText = document.querySelector(".variant-header-description");
const messageVariant = document.querySelector(".variant-message");
const variants = document.querySelectorAll('.variant-btn');
const addToList = document.querySelector('.add-to-project-list-btn');

const lengthLabel = document.querySelector('.length-label'); 
const lengthBtn = document.querySelector('.length-button'); 
const lengthDecrementBtn = document.querySelectorAll('.length-decrement-btn');
const lengthIncrementBtn = document.querySelectorAll('.length-increment-btn');
const lengthQty = document.querySelector('.l-counter');
const lengthEdit = document.getElementById("edit-length-value");

const quantityLabel = document.querySelector('.product-quantity-label');
const quantityBtn = document.querySelector('.pq-button');
const qtyIncrementBtn = document.querySelectorAll('.pq-increment-btn'); 
const qtyDecrementBtn = document.querySelectorAll('.pq-decrement-btn');
const productQty = document.querySelector('.pq-counter');
const qtyEdit = document.getElementById("edit-quantity-value");

// Shows or hides elements by setting their CSS display state
// Skips any elements not found on product page
function changeVisibility(elements, state) {
    for (let i =0; i < elements.length; i++) {  
        if (!elements[i]) {
            continue;
        }
        elements[i].style.display = state;  
    }
}

// Used by quantity and length buttons
// Decrements or increments a length or quantity counter
// Keeps selected value on the Add To Project in sync
function checkCounter(isIncrement, counter, attributeName) {
    let change = 0;
    if (isIncrement) {
        change += 1;
    } else {
        if (parseInt(counter.value) > 1) {
            change -= 1;
        }
    }
    addToList.dataset[attributeName] = parseInt(counter.value) + change;
    counter.value = parseInt(counter.value) + change;
}

// Initialises length and quantity's decrement and increment button event listeners 
// Done so the main product logic can enable length and shared quantity controls with a single function call
function setUpButtons() {
    lengthDecrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(false, lengthQty, 'selectedLength');
        })
    });

    lengthIncrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(true, lengthQty, 'selectedLength');
        })
    })

    setUpQtyButtons();
}

// Initialises quantity controls for products that don't require length
function setUpQtyButtons() {
    qtyDecrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(false, productQty, 'selectedQuantity');
        })
    });

    qtyIncrementBtn.forEach(element => {
        element.addEventListener("click", function(e) {
            checkCounter(true, productQty, 'selectedQuantity');
        })
    })
}

/* Shared by length and quantity inputs 
    Validates entered value and keeps the value displayed to the user consistent with the 
    value stored on the Add To Project button
    Values below 1 are reset to 1
*/
function checkInput(input, attributeName) {
    if (input.value <= 1) {
        addToList.dataset[attributeName] = 1;
        input.value = 1;
    } else {
        addToList.dataset[attributeName] = parseInt(input.value) ;
        input.value = parseInt(input.value);
    }
}

// Prevents the length input listener from being attached more than once
let lengthBound = false;

// Checks the length when the user types (changes the input)
function editLengthInput() {
    if (lengthBound) return;
    lengthEdit.addEventListener("input", function(e) {
        checkInput(e.target, 'selectedLength');
    });
    lengthBound = true;
}

// Prevents the quantity input listener from being attached more than once
let quantityBound = false;

// Checks the quantity when the user types (changes the input)
function editQtyInput() {
    if (quantityBound) return;
    qtyEdit.addEventListener("input", function(e) {
        checkInput(e.target, 'selectedQuantity');
    })
    quantityBound = true;
}


// Shows or hides product-page elements based on the selected product type
// Handles the initial setup of length, quantity, and variant controls.
function updatePage() {
    if (!addToList) return;

    // Reset controls and establish default values before determining product type
    changeVisibility([lengthLabel, lengthBtn, addToList], 'none');
    changeVisibility([quantityLabel, quantityBtn], 'none');
    addToList.dataset.selectedQuantity = '1';
    addToList.dataset.selectedLength = '1';
    changeVisibility([mainText, messageVariant], 'none');

    // Refer to project-tool-features.liquid for classification of product types
    const isLedStrip = lengthBtn.dataset.isLedStrip === 'true';
    const isProfile = lengthBtn.dataset.isProfile === 'true';
    const isCable = lengthBtn.dataset.isCable === 'true';

    /* LED STRIPS */

    /* LED strips with more than one variant, require the user to select
       a variant before product controls become available */ 
    if (isLedStrip && variants.length ) {

    changeVisibility([mainText, messageVariant], 'block');
    variants.forEach(element => {
        element.addEventListener("click", function(e) {
            addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
            addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
            addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
            addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
            addToList.dataset.selectedLength = e.target.dataset.variantLength; 
            addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;

            const variantSKU = e.target.dataset.variantSku.toLowerCase();
            const productTitle = addToList.dataset.title.toLowerCase();

            // LED Strips ending with M or Reels are sold by a specific length will have length controls hidden
            // LED Strip Controllers also have their length controls hidden.
            if (variantSKU.endsWith('m') || productTitle.includes('reel') || productTitle.includes('controller') || /\d+m(?=\s|$)/.test(productTitle)) {
                addToList.dataset.hasLength = 'false';
                changeVisibility([lengthLabel, lengthBtn], 'none');
            } else {
                addToList.dataset.hasLength = 'true';
                changeVisibility([lengthLabel], 'block');
                changeVisibility([lengthBtn], 'flex');
                
            }
            changeVisibility([quantityLabel], 'block');
            changeVisibility([quantityBtn], 'flex');
            changeVisibility([addToList], 'block');
            
            for (let i=0; i < variants.length; i++) {
                variants[i].classList.remove('active');
            }
            e.target.classList.add('active');

        })
        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();
    });
    setUpButtons();

    // LED strips with no variants displays all product controls: length and quantity
    } else if (isLedStrip){ 
        
        changeVisibility([mainText, messageVariant], 'none');

        const productSKU = addToList.dataset.sku.toLowerCase();
        const productTitle = addToList.dataset.title.toLowerCase();

        if (productSKU.endsWith('m') || productTitle.includes('reel') || productTitle.includes('controller') || /\d+m(?=\s|$)/.test(productTitle) ) {
            addToList.dataset.hasLength = 'false';
            changeVisibility([lengthLabel, lengthBtn], 'none');
        } else {
            addToList.dataset.hasLength = 'true';
            changeVisibility([lengthLabel], 'block');
            changeVisibility([lengthBtn], 'flex');
        }
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');
        setUpButtons();
        
        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();
    
    /* ALUMINIUM PROFILES */
    /* Aluminium profiles with more than one variant, require the user to select
       a variant before product controls become available */ 
    } else if (isProfile && variants.length) {
        
        changeVisibility([mainText], 'block');
        changeVisibility([messageVariant], 'block');
        
        variants.forEach(element => {
            element.addEventListener("click", function(e) {
                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
                addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
                addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
                addToList.dataset.selectedLength = e.target.dataset.variantLength; 
                addToList.dataset.productName = e.target.dataset.productTitle; 
                addToList.dataset.productSku = e.target.dataset.productSku; 
                addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;
                
                const sku = e.target.dataset.productSku;
                const variantType = e.target.dataset.variantSku;
                const variantName = e.target.dataset.variantTitle;

                // Most product variant parts are in variant names instead of its Sku
                // Retrieves product's accessories as variants
                const listedProfileNames = variantType?.toLowerCase().endsWith('m') || variantName?.toLowerCase().includes('end caps') 
                                        || variantName?.toLowerCase().includes('mounting clips')
                                        || variantName?.toLowerCase().includes('spring clips')
                                        || variantName?.toLowerCase().includes('joiner')
                                        || variantName?.toLowerCase().includes('centre rod');

                // Displays length controls depending on product variant
                if (variantName.toLowerCase().endsWith('diffuser') || variantType && !listedProfileNames) {
                    addToList.dataset.hasLength = 'true';
                    changeVisibility([lengthLabel], 'block');
                    changeVisibility([lengthBtn], 'flex');
                    lengthQty.value = 1;
                    editLengthInput();
                } else {
                    addToList.dataset.hasLength = 'false';
                    changeVisibility([lengthLabel, lengthBtn], 'none');
                }
                changeVisibility([quantityLabel], 'block');
                changeVisibility([quantityBtn], 'flex');
                changeVisibility([addToList], 'block');
                productQty.value = 1;
                editQtyInput();

                for (let i=0; i < variants.length; i++) {
                    variants[i].classList.remove('active');
                }
                e.target.classList.add('active');
            })
            
        });
        setUpButtons();
    
    // Aluminium profiles with no variants displays all product controls: length and quantity
    }  else if (isProfile) {
        
        addToList.dataset.selectedVariantSku = addToList.dataset.sku; 
        addToList.dataset.productName = addToList.dataset.title; 
        addToList.dataset.productSku = addToList.dataset.sku;

        const title = addToList.dataset.title;

        if (title.toLowerCase().includes('to suit') && !(title.toLowerCase().includes('long run') || title.toLowerCase().includes('channel') || title.toLowerCase().includes('diffuser'))) {
            addToList.dataset.hasLength = 'false';
        } else {
            addToList.dataset.hasLength = 'true';
        }
        
        changeVisibility([mainText, messageVariant], 'none');
        changeVisibility([lengthLabel], 'block');
        changeVisibility([lengthBtn], 'flex');
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');

        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();
        setUpButtons();
    

    /* CABLES */
    // Cables with no variants displays all product controls: length and quantity
    }   else if (isCable) { 
        
        addToList.dataset.selectedVariantSku = addToList.dataset.sku; 
        addToList.dataset.productName = addToList.dataset.title; 
        addToList.dataset.productSku = addToList.dataset.sku;
        addToList.dataset.hasLength = 'true';
        
        changeVisibility([mainText, messageVariant], 'none');
        changeVisibility([lengthLabel], 'block');
        changeVisibility([lengthBtn], 'flex');
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');

        setUpButtons();
        lengthQty.value = 1;
        productQty.value = 1;
        editLengthInput();
        editQtyInput();

    /* OTHER PRODUCT TYPES */
    // Products with more than one variant, require the user to select a variant before product controls become available
    }   else if (variants.length) { // Condition: Products that have variants and aren't led strips or, profiles
        changeVisibility([mainText], 'block');
        changeVisibility([messageVariant], 'block');
        changeVisibility([addToList], 'none');

        variants.forEach(element => {
            element.addEventListener("click", function(e) {
                changeVisibility([addToList], 'block');
                changeVisibility([quantityLabel], 'block');
                changeVisibility([quantityBtn], 'flex');
                changeVisibility([lengthLabel, lengthBtn], 'none');

                addToList.dataset.selectedVariant = e.target.dataset.variantTitle;
                addToList.dataset.selectedVariantSku = e.target.dataset.variantSku; 
                addToList.dataset.selectedVariantId = e.target.dataset.variantId; 
                addToList.dataset.selectedQuantity = e.target.dataset.variantQuantity; 
                addToList.dataset.selectedVariantImage = e.target.dataset.variantImage;
                addToList.dataset.hasLength = 'false';

                for (let i=0; i < variants.length; i++) {
                    variants[i].classList.remove('active');
                }
                e.target.classList.add('active');

            })
            productQty.value = 1;
            editQtyInput();
        });
        setUpQtyButtons();
    
    /* Products outside defined product types and without variants only displays quantity controls */
    } else {  
        addToList.dataset.hasLength = 'false';

        changeVisibility([mainText, messageVariant], 'none');
        changeVisibility([lengthLabel, lengthBtn], 'none');
        changeVisibility([quantityLabel], 'block');
        changeVisibility([quantityBtn], 'flex');
        changeVisibility([addToList], 'block');
        
        productQty.value = 1;
        editQtyInput();
        setUpQtyButtons();
    }
}

// Waits for HTML document and scripts to load before rendering to page
document.addEventListener("DOMContentLoaded", (event) => {
    updatePage();
});

